const selectors = {
  announcement: '[data-announcement-wrapper]',
  headerWrapper: '[data-header-wrapper]',
  header: '[data-header-wrapper] header',
};

const classes = {
  stuck: 'js__header__stuck',
  stuckAnimated: 'js__header__stuck--animated',
  triggerAnimation: 'js__header__stuck--trigger-animation',
  stuckBackdrop: 'js__header__stuck__backdrop',
  headerIsNotVisible: 'is-not-visible',
  hasStickyHeader: 'has-sticky-header',
};

const attributes = {
  transparent: 'data-header-transparent',
  stickyHeader: 'data-header-sticky',
  scrollLock: 'data-scroll-locked',
};

let sections = {};

class Sticky {
  constructor(el) {
    this.wrapper = el;
    this.type = this.wrapper.dataset.headerSticky;
    this.sticks = false;
    this.static = true;
    if (this.wrapper.hasAttribute(attributes.stickyHeader)) {
      this.sticks = true;
      this.static = false;
    }
    this.win = window;
    this.animated = this.type === 'directional';
    this.currentlyStuck = false;
    this.cls = this.wrapper.classList;
    const announcementEl = document.querySelector(selectors.announcement);
    const announcementHeight = announcementEl ? announcementEl.clientHeight : 0;
    this.headerHeight = document.querySelector(selectors.header).clientHeight;
    this.blur = this.headerHeight + announcementHeight;
    this.stickDown = this.headerHeight + announcementHeight;
    this.stickUp = announcementHeight;
    this.scrollEventStatic = () => this.checkIsVisible();
    this.scrollEventListen = (e) => this.listenScroll(e);
    this.scrollEventUpListen = () => this.scrollUpDirectional();
    this.scrollEventDownListen = () => this.scrollDownDirectional();
    if (this.wrapper.getAttribute(attributes.transparent) !== 'false') {
      this.blur = announcementHeight;
    }
    if (this.sticks) {
      this.stickDown = announcementHeight;
      this.scrollDownInit();
      document.body.classList.add(classes.hasStickyHeader);
    }

    if (this.static) {
      document.addEventListener('theme:scroll', this.scrollEventStatic);
    }

    this.listen();
  }

  unload() {
    if (this.sticks || this.animated) {
      document.removeEventListener('theme:scroll', this.scrollEventListen);
    }

    if (this.animated) {
      document.removeEventListener('theme:scroll:up', this.scrollEventUpListen);
      document.removeEventListener('theme:scroll:down', this.scrollEventDownListen);
    }

    if (this.static) {
      document.removeEventListener('theme:scroll', this.scrollEventStatic);
    }
  }

  listen() {
    if (this.sticks || this.animated) {
      document.addEventListener('theme:scroll', this.scrollEventListen);
    }

    if (this.animated) {
      document.addEventListener('theme:scroll:up', this.scrollEventUpListen);
      document.addEventListener('theme:scroll:down', this.scrollEventDownListen);
    }
  }

  listenScroll(e) {
    if (e.detail.down) {
      if (!this.currentlyStuck && e.detail.position > this.stickDown) {
        this.stickSimple();
      }
      if (!this.currentlyBlurred && e.detail.position > this.blur) {
        this.addBlur();
      }
    } else {
      if (e.detail.position <= this.stickUp) {
        this.unstickSimple();
      }
      if (e.detail.position <= this.blur) {
        this.removeBlur();
      }
    }
  }

  stickSimple() {
    if (this.animated) {
      this.cls.add(classes.stuckAnimated);
    }
    this.cls.add(classes.stuck);
    this.wrapper.setAttribute(attributes.transparent, false);
    this.currentlyStuck = true;
  }

  unstickSimple() {
    if (!document.documentElement.hasAttribute(attributes.scrollLock)) {
      // check for scroll lock
      this.cls.remove(classes.stuck);
      this.wrapper.setAttribute(attributes.transparent, theme.settings.transparentHeader);
      if (this.animated) {
        this.cls.remove(classes.stuckAnimated);
      }
      this.currentlyStuck = false;
    }
  }

  scrollDownInit() {
    if (window.scrollY > this.stickDown) {
      this.stickSimple();
    }
    if (window.scrollY > this.blur) {
      this.addBlur();
    }
  }

  stickDirectional() {
    this.cls.add(classes.triggerAnimation);
  }

  unstickDirectional() {
    this.cls.remove(classes.triggerAnimation);
  }

  scrollDownDirectional() {
    this.unstickDirectional();
  }

  scrollUpDirectional() {
    if (window.scrollY <= this.stickDown) {
      this.unstickDirectional();
    } else {
      this.stickDirectional();
    }
  }

  addBlur() {
    this.cls.add(classes.stuckBackdrop);
    this.currentlyBlurred = true;
  }

  removeBlur() {
    this.cls.remove(classes.stuckBackdrop);
    this.currentlyBlurred = false;
  }

  checkIsVisible() {
    const header = document.querySelector(selectors.headerWrapper);
    const isHeaderSticky = header.getAttribute(attributes.stickyHeader);
    const currentScroll = this.win.pageYOffset;

    if (!isHeaderSticky) {
      header.classList.toggle(classes.headerIsNotVisible, currentScroll >= this.headerHeight);
    }
  }
}

const stickyHeader = {
  onLoad() {
    sections = new Sticky(this.container);
  },
  onUnload: function () {
    if (typeof sections.unload === 'function') {
      sections.unload();
    }
  },
};

export default stickyHeader;
